<template>
  <div class="insert-ticket">
    <div class="select-user">
      <custom-validate-input :label="$t('tickets.general.labels.responder')"
                             class="w-full mb-5"
                             :disabled="true"
                             :in-valid="$v.ticket.user.$invalid"
                             @clicked="selectUserPromptStatus = true"
                             v-model="ticket.user.name"/>

      <div class="suggest-modal-button"
           @click="selectUserPromptStatus = true">
        <custom-icon height="22px" width="22px" icon="list-icon" color-code="#00bcd4"/>
      </div>

      <!-- users List prompt -->
      <custom-modal :active="selectUserPromptStatus"
                    size="very-big"
                    :fixed-height="true"
                    @close="selectUserPromptStatus = false">
        <template #header>
          <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
            <vs-row>
              <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
                <div @click="selectUserPromptStatus = true">
                  <custom-icon icon="plus-icon" color="success"/>
                </div>
              </vs-col>

              <vs-spacer/>

              <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
                {{ $t('users.list.title')}}
              </vs-col>

              <vs-spacer/>

              <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
                <div @click="selectUserPromptStatus = false">
                  <custom-icon icon="circle-x-icon" color="danger"/>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </template>
        <template #content>
          <div class="prompt-content py-2 px-3">
            <template>
              <keep-alive>
                <select-users :multi-select="false" @selected="handleUserSelected($event)"/>
              </keep-alive>
            </template>
          </div>
        </template>
      </custom-modal>

      <!-- insert new user prompt -->
      <custom-modal :active="insertUserPromptStatus"
                    :fixed-height="false"
                    @close="insertUserPromptStatus = false">
        <template #header>
          <div class="prompt-header p-3 w-full" :class="[!$vs.rtl ? 'rtl-only' : '']">
            <vs-row>
              <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
                <div @click="$u.click('insertUserBTN')">
                  <custom-icon icon="save-icon" color="success"/>
                </div>
              </vs-col>

              <vs-spacer/>

              <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
                {{ $t('users.insert.title') }}
              </vs-col>

              <vs-spacer/>

              <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
                <div @click="insertUserPromptStatus = false">
                  <custom-icon icon="circle-x-icon" color="danger"/>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </template>
        <template #content>
          <div class="prompt-content">
            <template>
              <keep-alive>
                <insert-user :in-modal="true" @inserted="handleNewUserInserted($event)"/>
              </keep-alive>
            </template>
          </div>
        </template>
      </custom-modal>
    </div>

    <custom-validate-input :label="$t('tickets.general.labels.subject')"
                           :placeholder="$t('tickets.general.placeholder.subject')"
                           :classes="{'w-full': true}"
                           :in-valid="$v.ticket.subject.$invalid"
                           v-model="ticket.subject"/>

    <custom-validate-textarea :label="$t('tickets.general.labels.message')"
                              :placeholder="$t('tickets.general.placeholder.message')"
                              :classes="{'w-full': true}"
                              :in-valid="$v.ticket.message.$invalid"
                              v-model="ticket.message"/>

    <div class="attachment-inputs-section">
      <div class="attach-inputs">
        <template v-for="(attach, key) in ticket.attaches">
          <custom-file-input :label="$t('tickets.general.labels.dynamicAttach', {number: key + 1})"
                             :is-empty="true"
                             :key="key"
                             logo-type="formData"
                             accept-type="*/*"
                             :styles="{width: '100%'}"
                             :preview="false"
                             :upload-text="$t('tickets.general.notifications.attachUpload')"
                             v-model="attach.file"
                             :disabled="false"/>
        </template>
      </div>
      <button class="insert-new-attach-btn" @click="handleInsertAttachInput">
        {{ $t('tickets.general.labels.insertAttach') }}
      </button>
    </div>

    <vs-button v-show="false"
               id="insertTicketBTN"
               @click="sendData"/>
  </div>
</template>

<script>
import axios from 'axios'
import CustomValidateInput from '@/components/input/customValidateInput'
import CustomValidateTextarea from '@/components/input/customValidateTextarea'
import CustomDialog from '@/components/dialog/customDialog'
import CustomSelect from '@/components/select/customSelect'
import CustomFileInput from '@/components/input/customeFileInput'
import CustomProfileImageInput from '@/components/input/customProfileImageInput'
import CustomIcon from '@/components/icon/customIcon'
import {insertTicket} from '@/http/requests/tickets'
import {required} from 'vuelidate/lib/validators'
import CustomModal from '@/components/modal/customModal.vue'
import InsertUser from '@/views/users/insert/InsertUser.vue'
import SelectUsers from '@/views/users/select/SelectUsers.vue'

export default {
  name: 'InsertTicket',
  components: {
    SelectUsers,
    InsertUser,
    CustomModal,
    CustomIcon,
    CustomProfileImageInput,
    CustomFileInput,
    CustomValidateTextarea,
    CustomSelect,
    CustomDialog,
    CustomValidateInput
  },
  data () {
    return {
      tabIndex: 1,
      suggestServicePromptStatus: false,
      insertUserPromptStatus: false,
      selectUserPromptStatus: false,
      ticket: {
        subject: {
          value: '',
          isValid: false
        },
        user: {
          id: 0,
          name: {
            value: '',
            isValid: true
          }
        },
        message: {
          value: '',
          isValid: false
        },
        attaches: [
          {
            file: {
              value: '',
              isValid: true
            }
          }
        ]
      }
    }
  },
  validations: {
    ticket: {
      subject: {
        value: {
          required
        }
      },
      message: {
        value: {
          required
        }
      },
      user: {
        id: {
          valid (value) { return value !== 0 }
        }
      }
    }
  },
  created () {
  },
  methods: {
    handleInsertAttachInput () {
      this.ticket.attaches.push({
        file: {
          value: '',
          isValid: true
        }
      })
    },
    handleNewUserInserted (user) {
      this.ticket.user.id = user.id
      this.ticket.user.name = {
        value: `${user.name} ${user.family}`,
        isValid: true
      }
      this.selectUserPromptStatus = false
      this.insertUserPromptStatus = false
    },
    handleUserSelected (list) {
      let user = {}
      list.forEach((data) => {
        if (!data.hasOwnProperty('show') || data.show) {
          user = {
            id: data.id,
            name: {
              value: data.name,
              isValid: true
            }
          }
        }
      })
      this.ticket.user = user
      this.selectUserPromptStatus = false
    },
    sendData () {
      if (this.$v.ticket.subject.$invalid) {
        this.$vs.notify({
          title: this.$t('others.alert.error.title'),
          text: this.$t('tickets.general.validators.subject'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.validators.subject')),
          color: 'danger'
        })
        return false
      }

      if (this.$v.ticket.message.$invalid) {
        this.$vs.notify({
          title: this.$t('others.alert.error.title'),
          text: this.$t('tickets.general.validators.message'),
          icon: 'icon-alert-circle',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.validators.message')),
          color: 'danger'
        })
        return false
      }

      const attaches = []
      const formData = new FormData()
      let attachCount = 0
      this.ticket.attaches.forEach((attach) => {
        if (attach.file.value) {
          attaches.push(formData)
          formData.append(`attachments[${attachCount}]`, attach.file.value)
          attachCount++
        }
      })

      formData.append('responder_id', this.ticket.user.id)
      formData.append('subject', this.ticket.subject.value)
      formData.append('message', this.ticket.message.value)

      insertTicket(formData).then(() => {
        this.$vs.notify({
          title: this.$t('others.alert.message.title'),
          text: this.$t('tickets.general.notifications.insert.success'),
          icon: 'icon-check',
          iconPack: 'feather',
          time: this.$u.getReadingTime(this.$t('tickets.general.notifications.insert.success')),
          color: 'success'
        })
        this.$emit('insert')
      }).catch((error) => {
        if (axios.isCancel(error)) {
          this.$vs.notify({
            title: this.$t('others.alert.duplicateRequest.title'),
            text: this.$t('others.alert.duplicateRequest.message'),
            icon: 'icon-alert-circle',
            iconPack: 'feather',
            time: this.$u.getReadingTime(this.$t('others.alert.duplicateRequest.message')),
            color: 'warning'
          })
        } else {
          const error_mapper = {
            'service_id': this.$t('tickets.general.notifications.parseError.service'),
            'subject': this.$t('tickets.general.notifications.parseError.subject'),
            'message': this.$t('tickets.general.notifications.parseError.message'),
            'attachments': this.$t('tickets.general.notifications.parseError.attachments')
          }

          switch (error.response.status) {
          case 422:
            Object.keys(error.response.data.errors).forEach((error_key) => {
              const err = error_key.toString().split('.')
              if (error_mapper[err[err.length - 1]]) {
                this.$vs.notify({
                  title: this.$t('others.alert.error.title'),
                  text: error_mapper[err[err.length - 1]],
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(error_mapper[err[err.length - 1]])
                })
                error_mapper[err[err.length - 1]] = null
              } else if (error_mapper[err[0]]) {
                this.$vs.notify({
                  title: this.$t('others.alert.error.title'),
                  text: error_mapper[err[0]],
                  color: 'danger',
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: this.$u.getReadingTime(error_mapper[err[0]])
                })
                error_mapper[err[0]] = null
              }
            })
            break

          default:
            this.$vs.notify({
              title: this.$t('others.alert.error.title'),
              text: this.$t('tickets.general.notifications.insert.error'),
              color: 'danger',
              icon: 'icon-alert-circle',
              iconPack: 'feather',
              time: this.$u.getReadingTime(this.$t('tickets.general.notifications.insert.error'))
            })
            break
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .insert-ticket {

    .select-type {
      .select-type-label {
        font-size: 17px;
        margin-bottom: 10px;
      }

      .ticket-type {
        display: flex;
        align-items: center;
        border: 1px solid #cdcdcd;
        border-radius: 0.5rem;
        padding: 15px 10px;
        margin-bottom: 10px;
        transition: all ease 0.5s;
        height: calc(100% - 50px);
        overflow-y: auto;

        .ticket-content {
          width: calc(100% - 40px);

          .ticket-title {
            font-size: 16px;
            margin-bottom: 10px;
          }

          .ticket-description {
            font-size: 14px;
          }
        }

        .ticket-arrow {
          width: 40px;
        }

        &:hover {
          cursor: pointer;
          background-color: #f5f5f5;
          transform: translateX(5px);
        }
      }
    }

    .select-user {
      position: relative;

      .suggest-modal-button, .new-suggest-modal-button {
        position: absolute;
        bottom: 0;
        right: 6px;
        top: 4px;
        width: 25px;
        height: 25px;
        padding: 0;
        border: 1px solid #197ed5;
        border-radius: .5rem;
        color: #197ed5;
        background: white;
        cursor: pointer;
      }
    }

    .attachment-inputs-section {
      display: flex;
      align-items: flex-start;

      .attach-inputs {
        flex-grow: 1;
        margin-right: 10px;
      }

      .insert-new-attach-btn {
        margin-top: 15px;
        padding: 5px 10px;
        border-radius: 0.5rem;
        border: 1px solid #cdcdcd;
        background-color: inherit;
        min-height: 36px;

        &:hover {
          background-color: #f0f0f0;
          cursor: pointer;
        }
      }
    }

    .custom-input:last-child {
      margin-bottom: 0;
    }

    .error-alert {
      display: inline-block;
      border: 1px solid #ffba00;
      border-radius: .5rem;
      color: #ffba00;
      padding: 0 10px;
      line-height: 50px;
      height: 50px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 15px;

      i {
        font-size: 15px;
      }
    }

    &::-webkit-scrollbar {
      display: block;
      border-radius: .2rem;
      width: 10px;
      background: #f9f9fd;
      right: 10px;
    }

    &::-webkit-scrollbar-thumb {
      display: block;
      border-radius: .2rem;
      background: #cecece;
    }
  }
</style>
